import { CombinedState } from '@reduxjs/toolkit';
import { RootStateType } from 'App/store';
import { StoreCategoryState } from '../../types';

export const getStoreCategoryState = (
  state: RootStateType,
): CombinedState<StoreCategoryState> => state.pagoNubeOnboarding.storeCategory;

export const getStoreCategoryData = (state: RootStateType) =>
  getStoreCategoryState(state).data;
